import React from 'react'
import GoogleClassroom from './../../components/GoogleClassroom';
import './TeacherDashboard.css';

const TeacherDashboard = () => {
  return (
    <div className='teacher-dashboard'>
      <h1>Teacher Dashboard</h1>
      <GoogleClassroom />
    </div>
  )
}

export default TeacherDashboard